import { useQuery } from '@apollo/client/react';

import type { Gec_Events_Bool_Exp } from '../../gql/graphql';
import { GET_FILTERED_EVENTS } from '../../graphql/queries';
import useBuildGraphQLVariables from '../useBuildGraphQLVariables/useBuildGraphQLVariables';

export function useFilteredEvents() {
  const filters: Gec_Events_Bool_Exp = useBuildGraphQLVariables();
  const { data, error, loading } = useQuery(GET_FILTERED_EVENTS, {
    variables: { filters: filters },
  });

  return { data, error, loading };
}
